export default class {
    constructor(Component) {
        this.Component = Component;
        /* sort result */
        this.Layout.sort.change(e => {
            e.preventDefault();
            let option = $(e.target).find('option:selected');
            this.Component.Interface
                .setSort(e.target.value, (option.data('invert')) ? 'desc' : 'asc')
                .sortResult(this.Component.Interface.result)
            ;
            this.Component.Interface.update();
        });
        /* Chance filters */
        this.Layout.container.on('change', 'input[name=filter]', e => {
            e.preventDefault();
            const Filter = this.Component.Interface.Filter;
            if (e.target.type === 'radio') {
                this.Component.getSiblingKeys(e.target.value).forEach(key => Filter.remove(key));
                Filter.add(e.target.value);
            } else {
                e.target.checked ?
                    Filter.add(e.target.value)
                    :
                    Filter.remove(e.target.value)
                ;
            }
        });

    }
    /* Constants */
    get Layout() { return this.Component.Layout }
}
